import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { siteData } from "../../data/siteData";

import "./FloatingWhatsApp.css";

function FloatingWhatsApp() {
  return (
    <a
      href={siteData.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-whatsapp"
    >
      <FaWhatsapp />
    </a>
  );
}

export default FloatingWhatsApp;
